// extracted by mini-css-extract-plugin
export default {"itemIcons":"style_itemIcons__VUy4q","itemIcon":"style_itemIcon__qyvU-"};